export default __webpack_public_path__ + "static/media/cd.4d75b378.svg";